// URL构建工具函数

// 获取API基础URL
// 前端: Cloudflare Pages | 后端: Zeabur
const getApiBaseUrl = () => {
    return process.env.REACT_APP_API_URL || 'https://xxxmemo-bk.zeabur.app/api';
};

// 取得 API 來源（不含 /api path）
const getApiOrigin = () => {
    const baseUrl = getApiBaseUrl();

    try {
        const { origin } = new URL(baseUrl);
        return origin;
    } catch (error) {
        // 若傳入的不是完整 URL，退而求其次移除尾端的 /api
        return baseUrl
            .replace(/\/api\/?$/, '')
            .replace(/\/$/, '');
    }
};

const normalizePath = (path) => {
    if (!path) return '';
    return path.startsWith('/') ? path : `/${path}`;
};

const shouldUseOrigin = (path) => {
    return path.startsWith('/media/') || path.startsWith('/static/');
};

const isInvalidAvatarStub = (path) => {
    const trimmed = path.replace(/\/+$/, '');
    return trimmed === '' || trimmed === '/avatar' || trimmed === 'avatar';
};

/**
 * 构建帖子图片URL（支持缩略图）
 * @param {string} imagePath - 图片路径
 * @param {string} size - 图片尺寸：'thumbnail' | 'medium' | 'original'
 * @returns {string|null} 图片URL
 */
export const getPostImageUrl = (imagePath, size = 'original') => {
    if (!imagePath) return null;

    // 如果已经是完整URL，直接返回
    if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
        return imagePath;
    }

    const normalizedPath = normalizePath(imagePath);
    const base = shouldUseOrigin(normalizedPath) ? getApiOrigin() : getApiBaseUrl();
    const fullUrl = `${base}${normalizedPath}`;

    // 如果后端支持缩略图，添加尺寸参数
    // 目前先返回原图，后端支持后可以添加 ?size=thumbnail 等参数
    if (size === 'thumbnail' || size === 'medium') {
        // 未来可以实现：return `${fullUrl}?size=${size}`;
        // 或使用不同的路径：return fullUrl.replace('/media/', `/media/${size}/`);
    }

    return fullUrl;
};

/**
 * 获取响应式图片的 srcSet
 * @param {string} imagePath - 图片路径
 * @returns {string} srcSet 字符串
 */
export const getImageSrcSet = (imagePath) => {
    if (!imagePath) return '';

    const thumbnail = getPostImageUrl(imagePath, 'thumbnail');
    const medium = getPostImageUrl(imagePath, 'medium');
    const original = getPostImageUrl(imagePath, 'original');

    // 生成 srcSet，未来后端支持不同尺寸时会自动生效
    return `${thumbnail} 400w, ${medium} 800w, ${original} 1200w`;
};

// 构建用户头像URL
export const getUserAvatarUrl = (avatarPath) => {
    if (!avatarPath) return null;

    // 如果已经是完整URL，直接返回
    if (avatarPath.startsWith('http://') || avatarPath.startsWith('https://')) {
        return avatarPath;
    }

    const normalizedPath = normalizePath(avatarPath);
    if (isInvalidAvatarStub(normalizedPath)) {
        return `${getApiOrigin()}/media/profile_pics/default-profile-pic.jpg`;
    }
    const base = shouldUseOrigin(normalizedPath) ? getApiOrigin() : getApiBaseUrl();

    return `${base}${normalizedPath}`;
};

// 构建媒体文件URL的通用函数
export const getMediaUrl = (mediaPath) => {
    if (!mediaPath) return null;

    // 如果已经是完整URL，直接返回
    if (mediaPath.startsWith('http://') || mediaPath.startsWith('https://')) {
        return mediaPath;
    }

    const normalizedPath = normalizePath(mediaPath);
    const base = shouldUseOrigin(normalizedPath) ? getApiOrigin() : getApiBaseUrl();

    return `${base}${normalizedPath}`;
};

// 构建API端点URL
export const getApiUrl = (endpoint) => {
    const baseUrl = getApiBaseUrl();

    // 确保端点以 / 开头
    const normalizedEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;

    return `${baseUrl}${normalizedEndpoint}`;
};
